import { useTheme } from "components/services/themeContext";

function SvgComponent({ size }) {
  const { theme } = useTheme();

  const imageSrc =
    theme === "light"
      ? "/images/media-kit/logos/dark_logo_redact.png"
      : "/images/media-kit/logos/white_logo_redact.png";

  // eslint-disable-next-line @next/next/no-img-element
  return <img src={imageSrc} alt="Redact logo" className={`${size ?? "h-[3.5rem]"}`} />;
}

export default SvgComponent;
